import axiosInstance from "../../utility/axios";

import { set_cookie, get_cookie, delete_cookie } from "../../utility/cookies";

// state
import { setLoading, disableLoading } from "../../store/slices/loading";
import { setAuth, setUser } from "../../store/slices/auth";
import { AppDispatch } from "../../store/store";
import { NavigateFunction } from "react-router-dom";
import type {
  ILogin,
  ILoginResponse,
  ILogoutRequest,
  ILogoutResponse,
} from "../../store/types/auth";

const authUrl = "/api/v1/admin/auth";

export const authUser = async (
  data: ILogin,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());

  try {
    const response = await axiosInstance.post<ILoginResponse>(
      `${authUrl}/login`,
      data,
    );

    const { success, data: loginData } = response.data;

    if (!success) throw new Error(response.data.message || "Login failed");

    set_cookie("@serial", loginData.tokens.access_token);
    set_cookie("@refresh_token", loginData.tokens.refresh_token);

    dispatch(setAuth(loginData.tokens));
    dispatch(setUser(loginData.user));

    navigate("/");
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(disableLoading());
  }
};

export const getAuthUser = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/user");
    dispatch(setUser(response.data));
  } catch (err) {
    console.log(err);
  }
  dispatch(disableLoading());
};

export const logout = async () => {
  const refreshToken = get_cookie("@refresh_token");
  try {
    if (refreshToken) {
      const data: ILogoutRequest = { refresh_token: refreshToken, all: false };
      const response = await axiosInstance.post<ILogoutResponse>(
        `${authUrl}/logout`,
        data,
      );
      if (!response.data.success) {
        throw new Error(response.data.message || "Logout failed");
      }
    }
  } finally {
    delete_cookie("@serial");
    delete_cookie("@refresh_token");
  }
};
